<template>




    <div class="row">  
                    


        <div class="col-lg-12">
            <h3 class="entry-title"> <i class="fas fa-lock"></i> Kalkulacja pozyczki </h3>   
        </div> 


        <div class="wrap column row justify-content-between d-none d-md-flex">
            

           
            <div id="kontomatik" class="column col-12" />





                <CalcSlider endpoint="http://localhost:8080" />






                <div class="form-group form-btn-wrap column col-10 col-mx-auto">

                    <input type="button" key="btn-main" class="button btn-prev" @click="gotomain" value="Powrót" />              
                       
                </div>


            </div>
        
        </div>









    </div>





</template>

<script>

    
    import CalcSlider from './CalcSlider'

    export default {
     
       name: 'ZetosCalcView',


       data(){

        return {

            // loanAmount pochodzi z mixinu common.js (proxy do loanStore) -
            // nie deklarujemy go lokalnie (kolizja z computed)
        }


       },


       components: { CalcSlider },


       methods: {


        gotomain(){


            this.$router.push({path: '/'});

        }
       },


       mounted() {


            // index.js
        





/*setTimeout(() => {
     
 var elems = document.getElementsByTagName('iframe');

                for (var i = 0; i<elems.length; i++) {
                   
                        elems[i].style.maxWidth = 'auto';
                    
                }




    }, 500);

          */ 

       }



        
    }
</script>



<style scoped>

h3 i {
    color: #0bc268;
}

.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}







</style>


// WEBPACK FOOTER //
// src/ZetosCalcView.vue